// extracted by mini-css-extract-plugin
var _1 = "txWhqqHWxp";
var _2 = "ejJIlY7P7m";
var _3 = "bzuDGHvLhT";
var _4 = "rSrl6XKFCR";
var _5 = "PuHfIMOr6_";
var _6 = "fyguqFjVCI";
export { _1 as "flexGrow1", _2 as "flexGrow2", _3 as "flexGrow3", _4 as "flexGrow4", _5 as "flexGrow5", _6 as "root" }
